module.exports = __webpack_public_path__ + "img/opened_incubator.b6d1b860.png";